import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { useDocumentMeta } from '../hooks/useDocumentMeta';

export default function NotFound() {
  useDocumentMeta('Pagina non trovata', undefined, { noindex: true });

  return (
    <section className="container py-24 text-center">
      <p className="text-6xl font-bold text-primary mb-4">404</p>
      <h1 className="text-3xl font-bold text-foreground mb-4">
        Pagina non trovata
      </h1>
      <p className="text-muted-foreground mb-8">
        La pagina che cerchi non esiste o è stata spostata.
      </p>
      <div className="flex justify-center gap-4">
        <Button asChild>
          <Link to="/">Torna alla home</Link>
        </Button>
        <Button asChild variant="outline">
          <Link to="/products">Vedi i prodotti</Link>
        </Button>
      </div>
    </section>
  );
}
